import { FormControl } from "@angular/forms";
import { ParentFieldFactory } from "../field-factory";
import { DynamicController } from "../dynamic-controller";
import { SingleFormFieldSetting } from "./single-form-field-setting";
import { FormContext } from "../../form/form-context";
import { FormFieldSettings } from "../../form-settings/form-field-settings";

export class DynamicSingleController<M = {}> extends DynamicController {
  constructor(
    private formControl: FormControl,
    private fieldFactory: ParentFieldFactory,
    private setting: SingleFormFieldSetting,
    private settings: FormFieldSettings
  ) {
    super();
  }

  public onInit(context: FormContext<M>) {}

  protected destory() {
    // TODO
  }
}
